var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-send_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 28 28",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20H6c-.6 0-1-.4-1-1v-2h12V8h4.7c1.1 0 1.6.6 1.9 1.1.6.9 1.5 2.4 2.1 3.4.2.3.3.7.3 1V18c0 1.1-.7 2-2 2h-1c0 1.7-1.3 3-3 3s-3-1.3-3-3h-4c0 1.7-1.3 3-3 3s-3-1.3-3-3zm3-1.2c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2-1.2-.5-1.2-1.2.5-1.2 1.2-1.2zm10 0c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2-1.2-.5-1.2-1.2.5-1.2 1.2-1.2zM10 10H2V8h8V7H5V6c0-.6.4-1 1-1h9c.6 0 1 .4 1 1v10H5v-3H3v-2h7v-1zm9 0v3h4.7l-1.4-2.5c-.2-.3-.5-.5-.9-.5H19z"
  })));
}

export default SvgIconSend;